/**
 * @generated SignedSource<<6fc4c1121480f5de1d67c8757b08f8d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleItemVariant_onSaleVertical$data = {
  readonly category: string | null;
  readonly displayName: string | null;
  readonly firstItemPhotoWebPath: string | null;
  readonly linkData: {
    readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
  };
  readonly " $fragmentType": "HpSharedFeaturedModuleItemVariant_onSaleVertical";
};
export type HpSharedFeaturedModuleItemVariant_onSaleVertical$key = {
  readonly " $data"?: HpSharedFeaturedModuleItemVariant_onSaleVertical$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleItemVariant_onSaleVertical">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModuleItemVariant_onSaleVertical",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "category",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "master"
        }
      ],
      "kind": "ScalarField",
      "name": "firstItemPhotoWebPath",
      "storageKey": "firstItemPhotoWebPath(size:\"master\")"
    }
  ],
  "type": "OnSaleVertical",
  "abstractKey": null
};

(node as any).hash = "968604f6c5b3337c43790d54685b8d72";

export default node;
